import { createFileRoute } from "@tanstack/react-router";
import CodeExplainerPage from "@/pages/CodeExplainerPage";

export const Route = createFileRoute("/tools/code-explainer")({
  component: CodeExplainerPage,
});
